import JBadge, { BadgeStatuses } from "$components/JBadge/JBadge";
import { STATUS_ORDERS } from "$hooks/useOrder";

function JBadgeList() {
  const renderRow = (status: BadgeStatuses) => (
    <tr key={status}>
      <td>
        <JBadge variant={status} messages={STATUS_ORDERS} />
      </td>
      <td>{status}</td>
    </tr>
  );
  return (
    <table>
      <tbody>
        {Object.values(BadgeStatuses).map((status) => renderRow(status))}
      </tbody>
    </table>
  );
}

export default JBadgeList;
